// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1zXVP","search":"Settings_search__3Pqr8","filter":"Settings_filter__3NfKB"};